












import { Vue, Component, Prop } from 'vue-property-decorator'
import { WingBlank, MainHead, HeadTabs } from '@/components/index'
import LeftSider from './components/LeftSider/index.vue'
import Table from './components/Table/index.vue'
import { WebhookPage } from '@/api/Webhook'
import { WebhookPageForm } from '@/types/Webhook'
@Component({
  components: {
    WingBlank,
    LeftSider,
    MainHead,
    HeadTabs,
    Table
  }
})
export default class WebhookAdmin extends Vue {
  /**
   * headTitle 头部标题
   * headData  头部展示数据
   * HeadImg   头部右侧图片
   * listArr   接口返回列表数据
   *
   * ResAllObjectList  接口规则
   */

  headTitle: string = 'Webhook管理';
  headData: string[] = [
    '管理和维护webhook，向任意外部系统按约定的方式推送数据，外部系统使用接收到的数据进行后续业务处理。',
    '创建好的webhook可在运营计划中当做执行器使用。',
  ];

  HeadImg: string = require('@/assets/images/u28.png');

  systemId:(number | null) = null
  form:WebhookPageForm = {}
  tableObj ={}
  async getTablePage() {
    const { systemId, form } = this
    if (!systemId) return
    const params:WebhookPageForm = {

      ...form,
      systemId,
    }

    const { data } = await WebhookPage(params)
    this.tableObj = data
  }
  handleClickCard(id: number) {
    this.systemId = id
    // this.getTablePage()
  }

  handleQueryPage(form:WebhookPageForm) {
    this.form = form
    this.getTablePage()
  }
}
